import React from 'react';
import ProgramsManager from '../Programs/ProgramsManager';
import { PROGRAM_TYPES } from '../../services/programsService';

const DesignABusiness = ({ userRole = 'client' }) => {
  return <ProgramsManager userRole={userRole} programType={PROGRAM_TYPES.DESIGN_A_BUSINESS} />;
};

export default DesignABusiness;
